import { NavLink } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { GraduationCap, BarChart3, LayoutDashboard, Users } from 'lucide-react';
import { useShellUserFirstName } from '../hooks/ShellUserFirstNameProvider';
import logo from '../../z30-images/logo_lyw_full_400x200.png';

const navItems = [
  { path: '/app', label: 'Dashboard', icon: LayoutDashboard, tourId: 'dashboard', end: true },
  { path: '/app/lessons', label: 'Plan', icon: GraduationCap, tourId: 'my-plan' },
  { path: '/app/reports', label: 'Reports', icon: BarChart3, tourId: 'reports' },
  { path: '/app/profiles', label: 'Profiles', icon: Users, tourId: 'profiles' },
];

export function Sidebar() {
  const { firstName } = useShellUserFirstName();
  const isDesktop = useMediaQuery({ query: '(min-width: 640px)' });

  return (
    <aside className="hidden sm:flex flex-col w-64 bg-white border-r border-gray-200 h-screen fixed left-0 top-0">
      {/* Header */}
      <div className="p-6 border-b border-gray-200 flex flex-col items-center">
        <NavLink to="/" className="block hover:opacity-80 transition-opacity mb-2">
          <img
            src={logo}
            alt="Learn Your Way"
            className="h-20 w-auto object-contain"
          />
        </NavLink>
        {firstName && (
          <p className="text-sm text-gray-600 mt-2 text-center break-words max-w-full px-2">
            Welcome, <span className="font-semibold text-gray-800">{firstName}</span>
          </p>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {navItems.map(({ path, label, icon: Icon, tourId, end }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={end}
                data-tour={isDesktop && tourId ? tourId : undefined}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-action-blue/10 text-action-blue-dark border border-action-blue/30'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`
                }
              >
                <Icon size={20} className="mr-3" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        {/* Footer content can be added here if needed */}
      </div>
    </aside>
  );
}
